import { RefObject, useEffect, useRef, useState } from "react";
import { useClickOutside, useGeneralSearch } from "../../hooks";
import {
  IGeneralSearchRequest,
  IGeneralSearchResponse,
} from "../../interfaces-and-types";
import { View } from "./View";

export interface IGeneralSearchBarViewProps {
  ref: RefObject<HTMLDivElement>;
  isLoading: boolean;

  searchText: string | null;
  setSearchText: (
    searchText: IGeneralSearchRequest["searchText"] | null
  ) => void;
  clearSearch: () => void;

  data: IGeneralSearchResponse | null;

  isEmptyResult: boolean;
  isEmptyQuery: boolean;

  dropDownClassName: string;
  showDropDown: () => void;
  hideDropDown: () => void;
}

export const GeneralSearchBar = () => {
  const {
    isLoading,

    searchText,
    setSearchText,

    data,
  } = useGeneralSearch();

  const clearSearch = () => {
    setSearchText("");
  };

  const ref = useRef<HTMLDivElement>(null);
  // const { open, setOpen } = useClickOutside(ref);

  // const isOpenRef = useRef<boolean>(false);
  // const open = isOpenRef.current;
  // const setOpen = (status: boolean) => (isOpenRef.current = status);

  const [open, setOpen] = useState(false);
  const closeOnClickOutside = () => setOpen(false);
  useClickOutside(ref, open, closeOnClickOutside);

  const showDropDown = () => setOpen(true);
  const hideDropDown = () => setOpen(false);

  const [dropDownClassName, setDropDownClassName] = useState("");

  let timeoutId = useRef<NodeJS.Timeout>();

  useEffect(() => {
    timeoutId.current = setTimeout(
      () => setDropDownClassName(open ? "show-dropdown" : ""),
      200
    );

    return () => timeoutId && clearTimeout(timeoutId.current);
  }, [open]);

  const isEmptyResult =
    (!data?.payments || data.payments.length === 0) &&
    (!data?.customers || data.customers.length === 0) &&
    (!data?.products || data.products.length === 0);

  const isEmptyQuery = !searchText || searchText === "";

  return (
    <View
      ref={ref}
      isLoading={isLoading}
      searchText={searchText}
      setSearchText={setSearchText}
      clearSearch={clearSearch}
      data={data}
      dropDownClassName={dropDownClassName}
      showDropDown={showDropDown}
      hideDropDown={hideDropDown}
      isEmptyResult={isEmptyResult}
      isEmptyQuery={isEmptyQuery}
    />
  );
};
